import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseCard } from './BaseCard';
import { YourRoleInReturnsCardProps } from './CardProps';
import { HorizontalBar } from '../HorizontalBar';

export const YourRoleInReturnsCard: React.FC<YourRoleInReturnsCardProps> = ({
  dashboardViewType,
  cardId,
  preparerCount,
  reviewerCount,
  maxRoleValue,
  handleRoleClick,
  getReturnsByRole,
  createSubmission,
}) => {
  const { t } = useTranslation();

  // Only show in My View
  if (dashboardViewType !== 'my') return null;

  return (
    <BaseCard
      cardId={cardId}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <HorizontalBar
          label={t('main.preparer')}
          value={preparerCount}
          maxValue={maxRoleValue}
          onClick={() => handleRoleClick('preparer')}
          returns={getReturnsByRole('preparer')}
          createSubmission={createSubmission}
        />
        <HorizontalBar
          label={t('main.reviewer')}
          value={reviewerCount}
          maxValue={maxRoleValue}
          onClick={() => handleRoleClick('reviewer')}
          returns={getReturnsByRole('reviewer')}
          createSubmission={createSubmission}
        />
      </div>
    </BaseCard>
  );
};

